<template>
    <div class="topbar">
        <b-navbar class="navbar-custom background-standard shadow-standard p-0">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="list-unstyled topbar-nav mb-0">
                    <b-nav-item class="d-none d-sm-inline">
                        <a href="#">
                            <span class="responsive-logo">
                                <img alt="logo-small" class="logo-sm align-self-center"
                                     height="34" src="@/assets/images/logo/s-stark.png">
                            </span>
                        </a>
                    </b-nav-item>
                    <b-nav-item>
                        <button :class="{ 'isDisabled': confirmView}" @click="enlargeMenu"
                                class="button-menu-mobile nav-link">
                            <i class="fas fa-bars font-20 text-white"></i>
                        </button>
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto pr-4">
                    <b-nav-item-dropdown id="nav7_ddown" right toggle-class="mr-2">
                        <template slot="button-content">
                            <img height="15" src="@/assets/images/flags/french_flag.jpg"> <i
                                class="font-12 fas fa-chevron-down sm"></i>
                        </template>
                        <b-dropdown-item class="py-2">Français <img class="float-right"
                                                                    height="20"
                                                                    src="@/assets/images/flags/french_flag.jpg">
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown :class="{ 'headerConfirmation': confirmView}" right
                                         toggle-class="waves-effect waves-light nav-user mr-4">
                        <template v-slot:button-content>
                            <span class="ml-1 nav-user-name hidden-sm">Bonjour, {{firstName}} <i
                                    class="font-12 fas fa-chevron-down sm"></i> </span>
                        </template>
                        <b-dropdown-item link-class="p-0">
                            <router-link to="/profile"><a class="dropdown-item"><i
                                    class="fas fa-user text-muted mr-2"></i> Profil</a></router-link>
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item link-class="p-0">
                            <a @click="onLogout" class="dropdown-item">
                                <i class="fas fa-sign-out-alt text-muted mr-2"></i> Se déconnecter
                            </a>
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown disabled right toggle-class="waves-effect waves-light nav-user mr-4"
                                         v-if="confirmView">
                        <template v-slot:button-content>
                            <span class="ml-1 nav-user-name hidden-sm">Bonjour <i
                                    class="font-12 fas fa-chevron-down sm"></i> </span>
                        </template>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        name: 'AppHeader.vue',
        components: {},
        props: {
            confirmView: Boolean
        },
        data() {
            return {
                role: null
            };
        },
        computed: {
            firstName() {
                return this.$store.getters.user.firstName;
            }
        },
        created() {
            this.role = this.$store.getters.role;
        },
        methods: {
            enlargeMenu() {
                this.$emit('enlargeMenu', true);
            },
            onLogout() {
                this.$store.dispatch('logout');
            }
        }
    };
</script>

<style scoped>
    .dropdown-header {
        padding: 0;
    }

    a:not([href]) {
        color: #000444;
        text-decoration: none;
    }

    .headerConfirmation {
        display: none;
    }

    .isDisabled {
        color: currentColor;
        cursor: not-allowed;
        opacity: 0.5;
        text-decoration: none;
        pointer-events: none;
    }
</style>
